"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarMenuSection = void 0;
const material_1 = require("@mui/material");
const svgs_1 = require("../assets/svgs");
const react_1 = require("react");
const react_2 = __importStar(require("react"));
const lodash_debounce_1 = __importDefault(require("lodash.debounce"));
const SideBarOpenStateStore_1 = __importDefault(require("../utils/zustand-stores/SideBarOpenStateStore"));
function NavBarMenuSection({ sx, children, ...rest }) {
    const [windowWidth, setWindowWidth] = (0, react_1.useState)(0);
    const { isOpen, setOpen } = (0, SideBarOpenStateStore_1.default)();
    const defaultSX = {
        width: '2.5rem',
        height: '2.5rem',
        display: 'flex',
        alignItems: 'center',
        minWidth: '2.5rem',
        padding: '0px',
        margin: '0px',
    };
    const mergedSX = { ...defaultSX, ...sx };
    (0, react_2.useEffect)(() => {
        if (typeof window !== 'undefined') {
            const handleResize = () => {
                setWindowWidth(window.innerWidth);
            };
            const debouncedHandleResize = (0, lodash_debounce_1.default)(handleResize, 150);
            setWindowWidth(window.innerWidth);
            window.addEventListener('resize', debouncedHandleResize);
            return () => {
                window.removeEventListener('resize', debouncedHandleResize);
            };
        }
        return () => { };
    }, []);
    (0, react_2.useEffect)(() => {
        if (isOpen && windowWidth > 900) {
            setOpen(false); // Close the drawer
        }
    }, [isOpen, windowWidth]);
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(material_1.Button, { sx: mergedSX, onClick: () => setOpen(true), ...rest },
            react_2.default.createElement(svgs_1.Menu, null)),
        react_2.default.createElement(material_1.Drawer, { open: isOpen, onClose: () => setOpen(false) },
            react_2.default.createElement("div", null,
                react_2.default.createElement("button", { className: "fixed top-[1.5rem] right-[0.5rem] sm:right-auto left-auto sm:left-[308px] p-[0.5rem]", onClick: () => setOpen(false) },
                    react_2.default.createElement(svgs_1.CloseFilled, null)),
                children))));
}
exports.NavBarMenuSection = NavBarMenuSection;
